import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { InformationOutline } from "pcln-icons";
import { Flex, GenericBanner, Text } from "pcln-design-system";
import analytics from "../../analytics/analytics.js";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
import { useLoadingStateContext } from "../../hooks/useLoadingStateContext.js";
const TryAgain = ({ lastMessage })=>{
    useEffect(()=>{
        analytics.log({
            message: `TryAgain-component: ${lastMessage}`,
            source: 'TryAgain'
        });
    }, [
        lastMessage
    ]);
    let setOpenErrorComponent, setLoadingStatus;
    try {
        const chatUIContext = useChatUIContext();
        setOpenErrorComponent = chatUIContext?.setOpenErrorComponent;
    } catch (error) {
        console.warn('TryAgain: useChatUIContext must be used within a ChatUIContextProvider');
        setOpenErrorComponent = ()=>{};
    }
    try {
        const loadingStateContext = useLoadingStateContext();
        setLoadingStatus = loadingStateContext?.setLoadingStatus;
        useEffect(()=>{
            if (setLoadingStatus) setLoadingStatus(false);
        }, [
            setLoadingStatus
        ]);
    } catch (error) {
        console.warn('TryAgain: useLoadingStateContext must be used within a LoadingStateProvider');
        setLoadingStatus = ()=>{};
    }
    const tryAgainHandler = function() {
        if (setOpenErrorComponent) setOpenErrorComponent(false);
    };
    return /*#__PURE__*/ jsx(Flex, {
        flexDirection: "column",
        justifyContent: "center",
        "data-testid": "try-again",
        children: /*#__PURE__*/ jsx(GenericBanner, {
            mx: 3,
            my: 3,
            p: 2,
            borderRadius: "lg",
            color: "background.light",
            iconLeft: /*#__PURE__*/ jsx(InformationOutline, {
                color: "warning.base",
                "data-testid": "information-outline-icon"
            }),
            text: /*#__PURE__*/ jsxs(Text.span, {
                textStyle: "subheading6",
                children: [
                    "I'm having some trouble coming up with a response right now.\xa0",
                    /*#__PURE__*/ jsx(Text.span, {
                        color: "primary.base",
                        textStyle: "heading6",
                        style: {
                            textDecoration: 'none !important'
                        },
                        children: "Please try again."
                    })
                ]
            }),
            buttonClick: tryAgainHandler
        })
    });
};
const TryAgain_TryAgain = TryAgain;
export { TryAgain_TryAgain as default };
